import PwaNetworkStatusController from "./pwa/network_status_controller"

// Chat app network status -- thin wrapper over the shared PWA controller.
// No service worker sync, no logging.

export default class extends PwaNetworkStatusController {
  static values = {
    ...PwaNetworkStatusController.values,
    prefix:        { type: String, default: "chat" },
    swSyncEnabled: { type: Boolean, default: false }
  }
}
